import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MaskAndValid from "utils/maskAndValid";

export default function PersonalDataForm({
  open,
  onClose,
  nameInput,
  setNameInput,
  cpfInput,
  setCpfInput,
  phoneInput,
  setPhoneInput,
  emailInput,
  setEmailInput,
  birthDateInput,
  setBirthDateInput,
  deliveryAddressExpanded,
  setDeliveryAddressExpanded,
  deliveryCep,
  setDeliveryCep,
  deliveryStreet,
  setDeliveryStreet,
  deliveryNumber,
  setDeliveryNumber,
  deliveryNeighborhood,
  setDeliveryNeighborhood,
  deliveryCity,
  setDeliveryCity,
  deliveryUf,
  setDeliveryUf,
  deliveryComplement,
  setDeliveryComplement,
  cepLoading,
  fetchDeliveryAddressByCep,
  error,
  onSubmit,
  brandColors,
}) {
  if (!open) return null;

  const handleCepBlur = async () => {
    const digits = deliveryCep.replace(/\D/g, "");
    if (digits.length === 8) {
      await fetchDeliveryAddressByCep(digits);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: `1px solid ${brandColors.border}`,
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 60,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: brandColors.surface,
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          padding: "24px",
          maxWidth: "480px",
          width: "90%",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: brandColors.textMuted,
          }}
          onMouseEnter={(e) => {
            e.target.style.color = brandColors.textBase;
          }}
          onMouseLeave={(e) => {
            e.target.style.color = brandColors.textMuted;
          }}
        >
          <CloseIcon style={{ fontSize: "24px" }} />
        </button>
        <h3
          style={{
            textAlign: "center",
            marginBottom: "24px",
            marginTop: "8px",
          }}
        >
          Preencha seus dados para finalizar a vitrine
        </h3>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Nome *
          </label>
          <input
            type="text"
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            style={inputStyle}
            placeholder="Digite seu nome"
            maxLength={150}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>CPF *</label>
          <input
            type="text"
            value={cpfInput}
            onChange={(e) => setCpfInput(MaskAndValid.maskCPF(e.target.value))}
            style={inputStyle}
            placeholder="Informe seu CPF"
            maxLength={14}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Data de nascimento *
          </label>
          <input
            type="date"
            value={birthDateInput}
            onChange={(e) => setBirthDateInput(e.target.value)}
            style={inputStyle}
            min="1900-01-01"
            max="2100-12-31"
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Telefone *
          </label>
          <input
            type="text"
            value={phoneInput}
            onChange={(e) =>
              setPhoneInput(MaskAndValid.maskPhone(e.target.value))
            }
            style={inputStyle}
            placeholder="Informe seu telefone"
            maxLength={15}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            E-mail *
          </label>
          <input
            type="email"
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
            style={inputStyle}
            placeholder="Informe seu e-mail"
            maxLength={100}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <button
            type="button"
            onClick={() => setDeliveryAddressExpanded(!deliveryAddressExpanded)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              padding: "10px 12px",
              background: brandColors.surface,
              color: brandColors.textBase,
              border: `1px solid ${brandColors.border}`,
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            <ExpandMoreIcon
              style={{
                fontSize: "22px",
                transition: "transform 0.2s",
                transform: deliveryAddressExpanded
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            />
            Informar endereço de entrega
          </button>
        </div>

        {deliveryAddressExpanded && (
          <>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                CEP * {cepLoading ? "(buscando…)" : ""}
              </label>
              <input
                type="text"
                value={deliveryCep}
                onChange={(e) =>
                  setDeliveryCep(MaskAndValid.maskCEP(e.target.value))
                }
                onBlur={handleCepBlur}
                disabled={cepLoading}
                style={{
                  ...inputStyle,
                  opacity: cepLoading ? 0.7 : 1,
                }}
                placeholder="00000-000"
                maxLength={9}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Logradouro *
              </label>
              <input
                type="text"
                value={deliveryStreet}
                onChange={(e) => setDeliveryStreet(e.target.value)}
                style={inputStyle}
                placeholder="Rua, avenida…"
                maxLength={200}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Número *
              </label>
              <input
                type="text"
                value={deliveryNumber}
                onChange={(e) => setDeliveryNumber(e.target.value)}
                style={inputStyle}
                placeholder="Nº"
                maxLength={20}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Bairro *
              </label>
              <input
                type="text"
                value={deliveryNeighborhood}
                onChange={(e) => setDeliveryNeighborhood(e.target.value)}
                style={inputStyle}
                placeholder="Bairro"
                maxLength={120}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Cidade *
              </label>
              <input
                type="text"
                value={deliveryCity}
                onChange={(e) => setDeliveryCity(e.target.value)}
                style={inputStyle}
                placeholder="Cidade"
                maxLength={120}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                UF *
              </label>
              <input
                type="text"
                value={deliveryUf}
                onChange={(e) =>
                  setDeliveryUf(
                    e.target.value
                      .toUpperCase()
                      .replace(/[^A-Za-z]/g, "")
                      .slice(0, 2)
                  )
                }
                style={inputStyle}
                placeholder="UF"
                maxLength={2}
              />
            </div>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Complemento
              </label>
              <input
                type="text"
                value={deliveryComplement}
                onChange={(e) => setDeliveryComplement(e.target.value)}
                style={inputStyle}
                placeholder="Opcional"
                maxLength={120}
              />
            </div>
          </>
        )}

        {error && (
          <p style={{ color: "#d32f2f", marginBottom: "16px" }}>{error}</p>
        )}
        <button
          type="button"
          onClick={onSubmit}
          style={{
            width: "100%",
            padding: "12px",
            background: brandColors.primary,
            color: "#fff",
            border: 0,
            borderRadius: "4px",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
            opacity: 1,
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = brandColors.primaryHover;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = brandColors.primary;
          }}
        >
          Finalizar Vitrine
        </button>
      </div>
    </div>
  );
}
